import { Grid, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MainContainer = styled(Grid)({
  padding: "10px 0px",
  display: "flex",
  flexDirection: "column",
  gap: "40px",
});

export const Container = styled(Grid)({
  padding: "10px 0px",
  minHeight: "fit-content",
  maxHeight: "60vh",
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  gap: "30px",
});

export const DetailsContainner = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const ActionButtons = styled(Button, {
  shouldForwardProp: (prop) => prop !== "reject",
})<{ reject?: boolean }>(
  ({ theme }) => ({
    textTransform: "none",
    color: theme.palette.success.main,
  }),
  ({ reject, theme }) => ({
    ...(!!reject && {
      color: theme.palette.error.main,
    }),
  })
);
